import React from 'react';
import PropTypes from 'prop-types';
import { GetScope } from '../../features/authentication/hooks/useToken';
import { Link, useParams } from 'react-router-dom';
import { useQuery, gql } from '@apollo/client';
import { getCall } from '../../hooks/Network';
import { useTranslation } from 'react-i18next';
import { cacheGet } from '../../util/cache';

var GET_DATA = gql`
  query {
    trees {
      id
      name
    }
  }
`;

// Customer Nav Component

const CustomerNav = ({ customerId, pageId }) => {
  const { t } = useTranslation();
  const params = useParams();

  const queryParams = new URLSearchParams(window.location.search);
  const periodId = queryParams.get('periodId');
  const { data } = useQuery(GET_DATA, {
    variables: {},
  });
  const subscriptions = cacheGet('subscriptions', true, []);
  const apiToken = cacheGet('apiToken', true, { jwtToken: '' });
  const bearerToken = apiToken.jwtToken;

  // Get Defiverse Function
  const getDefiverse = async () => {
    let getData = {
      url: 'defiverse',
      urlParams: {
        AssociateId: params.customerId,
      },
      headers: { Authorization: 'Bearer ' + bearerToken },
    };
    const resp = await getCall(getData);

    if (resp.data) {
      window.open(resp.data.login_url, '_blank', 'noopener,noreferrer');
    }
  };

  return (
    <>
      <ul className='navbar-nav flex-row gap-4'>
        <li className={`nav-item ${activeClass(pageId, 'summary')}`}>
          <Link
            className='nav-link'
            to={`/customers/${customerId}/summary${periodId ? '?periodId=' + periodId : ''}`}
          >
            <span className='nav-link-title'>{t('summary')}</span>
          </Link>
        </li>
        <li className={`nav-item ${activeClass(pageId, 'orders')}`}>
          <Link
            className='nav-link'
            to={`/customers/${customerId}/orders${periodId ? '?periodId=' + periodId : ''}`}
          >
            <span className='nav-link-title text-nowrap'>{t('orderHistory')}</span>
          </Link>
        </li>
        <li className={`nav-item ${activeClass(pageId, 'autoshipsummary')}`}>
          <Link
            className='nav-link'
            to={`/customers/${customerId}/autoshipsummary${periodId ? '?periodId=' + periodId : ''}`}
          >
            <span className='nav-link-title text-nowrap'>{t('manageAutoShip')}</span>
          </Link>
        </li>

        <li className={`nav-item ${activeClass(pageId, 'commissions')}`}>
          <Link
            className='nav-link'
            to={`/customers/${customerId}/commissions${periodId ? '?periodId=' + periodId : ''}`}
          >
            <span className='nav-link-title'>{t('earnings')}</span>
          </Link>
        </li>

        {GetScope() == null && (
          <li className={`nav-item ${activeClass(pageId, 'dashboard')}`}>
            <Link
              className='nav-link'
              to={`/customers/${customerId}/dashboard${periodId ? '?periodId=' + periodId : ''}`}
            >
              <span className='nav-link-title'>{t('dashboard')}</span>
            </Link>
          </li>
        )}
        {GetScope() == null && (
          <li className={`nav-item ${activeClass(pageId, 'training')}`}>
            <Link
              className='nav-link'
              to={`/customers/${customerId}/training${periodId ? '?periodId=' + periodId : ''}`}
            >
              <span className='nav-link-title'>{t('training')}</span>
            </Link>
          </li>
        )}
        {GetScope() == null && (
          <li className={`nav-item ${activeClass(pageId, 'account')}`}>
            <Link
              className='nav-link'
              to={`/customers/${customerId}/account/profile${periodId ? '?periodId=' + periodId : ''}`}
            >
              <span className='nav-link-title'>{t('account')}</span>
            </Link>
          </li>
        )}
        <li className={`nav-item dropdown ${activeClass(pageId, 'tree')}`}>
          <a
            className='nav-link dropdown-toggle'
            href='#trees'
            data-bs-toggle='dropdown'
            data-bs-auto-close='outside'
            role='button'
            aria-expanded='false'
          >
            <span className='nav-link-title'>{t('trees')}</span>
          </a>
          <div className='dropdown-menu'>
            {data?.trees &&
              data?.trees.map((tree) => {
                return (
                  <a
                    key={tree.id}
                    className='dropdown-item'
                    href={`/customers/${customerId}/tree/${tree.id}${periodId ? '?periodId=' + periodId : ''}`}
                  >
                    {tree.name} {t('tree')}
                  </a>
                );
              })}
          </div>
        </li>

        <li
          className={`nav-item dropdown subscription-menus ${activeClass(pageId, 'forex')}`}
        >
          <a
            className='nav-link dropdown-toggle'
            href='#forex'
            data-bs-toggle='dropdown'
            data-bs-auto-close='outside'
            role='button'
            aria-expanded='false'
          >
            <span className='nav-link-title'>{t('forex')}</span>
          </a>
          <div className='dropdown-menu'>
            {subscriptions &&
              Object.values(subscriptions).map((item) => {
                if (item.name == 'Solexx') {
                  return (
                    <a
                      key={`${subscriptions.id}${item.name}`}
                      className='dropdown-item'
                      href={`/customers/${customerId}/solexx`}
                    >
                      {t('solexx')}
                    </a>
                  );
                } else if (item.name == 'Maitryx') {
                  return (
                    <a
                      key={`${subscriptions.id}${item.name}`}
                      className='dropdown-item'
                      href={`/customers/${customerId}/Maitryx`}
                    >
                      {t('manara')}
                    </a>
                  );
                } else if (item.name == 'Ploutos') {
                  return (
                    <a
                      key={`${subscriptions.id}${item.name}`}
                      className='dropdown-item'
                      href={`/customers/${customerId}/ploutos`}
                    >
                      {t('ploutos')}
                    </a>
                  );
                } else if (item.name == 'RFX') {
                  return (
                    <a
                      key={`${subscriptions.id}${item.name}`}
                      className='dropdown-item'
                      href={`/customers/${customerId}/rfx`}
                    >
                      {t('rfx')}
                    </a>
                  );
                } else if (item.name == 'Forex Espanol') {
                  return (
                    <a
                      key={`${subscriptions.id}${item.name}`}
                      className='dropdown-item'
                      href={`/customers/${customerId}/forex-espanol`}
                    >
                      {t('forexEspanol')}
                    </a>
                  );
                } else if (item.name == 'Opciones Binarias') {
                  return (
                    <a
                      key={`${subscriptions.id}${item.name}`}
                      className='dropdown-item'
                      href={`/customers/${customerId}/opciones-binarias`}
                    >
                      {t('opcionesBinarias')}
                    </a>
                  );
                } else if (item.name == 'Eacho') {
                  return (
                    <a
                      key={`${subscriptions.id}${item.name}`}
                      className='dropdown-item'
                      href={`/customers/${customerId}/eacho`}
                    >
                      {t('eacho')}
                    </a>
                  );
                } else if (item.name == 'ECA') {
                  return (
                    <a
                      key={`${subscriptions.id}${item.name}`}
                      className='dropdown-item'
                      href={`/customers/${customerId}/eca`}
                    >
                      {t('eca')}
                    </a>
                  );
                }
              })}
          </div>
        </li>

        <li
          className={`nav-item dropdown subscription-menus ${activeClass(pageId, 'stock')}`}
        >
          <a
            className='nav-link dropdown-toggle'
            href='#stock'
            data-bs-toggle='dropdown'
            data-bs-auto-close='outside'
            role='button'
            aria-expanded='false'
          >
            <span className='nav-link-title'>{t('stock')}</span>
          </a>
          <div className='dropdown-menu'>
            {subscriptions &&
              Object.values(subscriptions).map((item) => {
                if (item.name == 'Eminus Ideas') {
                  return (
                    <a
                      key={subscriptions.id}
                      className='dropdown-item'
                      href={`/customers/${customerId}/eminus-ideas`}
                    >
                      {t('eminusIdeas')}
                    </a>
                  );
                } else if (item.name == 'ECA') {
                  return (
                    <a
                      key={subscriptions.id}
                      className='dropdown-item'
                      href={`/customers/${customerId}/eca-stock`}
                    >
                      {t('eca')}
                    </a>
                  );
                } else if (item.name == 'Defiverse') {
                  return (
                    <a
                      key={subscriptions.id}
                      className='dropdown-item'
                      onClick={() => getDefiverse()}
                    >
                      {t('defivrse')}
                    </a>
                  );
                }
              })}
          </div>
        </li>

        <li
          className={`nav-item dropdown subscription-menus ${activeClass(pageId, 'skie')}`}
        >
          <a
            className='nav-link dropdown-toggle'
            href='#skie'
            data-bs-toggle='dropdown'
            data-bs-auto-close='outside'
            role='button'
            aria-expanded='false'
          >
            <span className='nav-link-title'>{t('skie')}</span>
          </a>
          <div className='dropdown-menu'>
            {subscriptions &&
              Object.values(subscriptions).map((item) => {
                if (item.name == 'Cloud VPS') {
                  return (
                    <a
                      key={subscriptions.id}
                      className='dropdown-item'
                      href={`/customers/${customerId}/cloud-vps`}
                    >
                      {t('cloudVPS')}
                    </a>
                  );
                } else if (item.name == 'Delete4x') {
                  return (
                    <a
                      key={subscriptions.id}
                      className='dropdown-item'
                      href={`/customers/${customerId}/delete4x`}
                    >
                      {t('delete')}4x
                    </a>
                  );
                }
              })}
          </div>
        </li>
      </ul>
    </>
  );
};

function activeClass(current, pageId) {
  if (current == pageId) return 'active';
  return '';
}

export default CustomerNav;

CustomerNav.propTypes = {
  customerId: PropTypes.string.isRequired,
  pageId: PropTypes.string,
  onSearch: PropTypes.func,
};
